import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import RFQ from "./pages/RFQ";
import HomePage from "./pages/Home";
import ScrollToTop from "./Components/ScrollToTop";

/* ---------------- THEME ---------------- */

export const THEME = {
  colors: {
    bg: "#09090b",
    bgDrawer: "#18181b",
    textMain: "#ffffff",
    textMuted: "#a1a1aa",
    primary: "#dc2626",
    primaryDark: "#b91c1c",
    accent: "#C9A227",
    accentGradient:
      "linear-gradient(135deg, #B8962E 0%, #FFD97A 50%, #8F6B1F 100%)",
    border: "#27272a",
    overlay: "rgba(9, 9, 11, 0.6)",
  },
  fonts: {
    body: "sans-serif",
  },
};

/* ---------------- NAV ---------------- */

export const NAV_LINKS = [
  { name: "HOME", href: "#hero" },
  { name: "SECTORS", href: "#divisions" },
  { name: "ABOUT", href: "#about" },
  { name: "PARTNERS", href: "#partners" },
  { name: "CERTIFICATIONS", href: "#certificates" },
  { name: "PRODUCTS", href: "#products" },
  { name: "DOWNLOAD", href: "#download" },
];

/* ---------------- HOOKS ---------------- */

const useWindowWidth = () => {
  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200,
  );

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return width;
};

/* ---------------- SCROLL ---------------- */

export const handleScrollTo = (e, id) => {
  e.preventDefault();
  const element = document.querySelector(id);
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }
};

/* ================= APP ================= */

const App = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const windowWidth = useWindowWidth();
  const isDesktop = windowWidth >= 1024;

  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? "hidden" : "unset";
  }, [isMobileMenuOpen]);

  const handleSplashComplete = () => {
    setIsLoading(false);
  };

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <HomePage
              isDesktop={isDesktop}
              isMobileMenuOpen={isMobileMenuOpen}
              setIsMobileMenuOpen={setIsMobileMenuOpen}
              isLoading={isLoading}
              handleSplashComplete={handleSplashComplete}
              THEME={THEME}
            />
          }
        />

        <Route path="/rfq" element={<RFQ THEME={THEME} />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
